import IconButton from "components/Button/IconButton";
import { dateTimeToStr, simpleAlert } from "components/CommonLib/CommonLib";
import Loading from "components/Loading/Loading/Loading";
import CryptoJS from "crypto-js";
import { addDoc, collection } from "firebase/firestore";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { db } from "../../firebase";
import { exportCartToExcel } from "./makeExcel";

const SECRET_KEY = process.env.REACT_APP_ESTIMATE_SECRET_KEY;

const CartSidebar = ({
  onClear,
  cartItems,
  onRemoveItem,
  onAddItem,
  setIsAuth,
  setIsHistoryModalOpen,
}) => {
  const storesDispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const selectedBranch = sessionStorage.getItem("branch");
  // const [selectedBranch, setSelectedBranch] = useState("");
  // 총 아이템 수량
  const totalQuantity = cartItems.reduce((acc, i) => acc + i.quantity, 0);

  // 지점 검증
  const verifyBranch = () => {
    const saved = sessionStorage.getItem("branch");
    const sig = sessionStorage.getItem("branch_sig");

    if (!saved || !sig) return false;

    const expected = CryptoJS.HmacSHA256(saved, SECRET_KEY).toString();
    return sig === expected;
  };

  const onClickEstimate = () => {
    if (cartItems.length === 0) return;
    if (!verifyBranch()) {
      simpleAlert(
        storesDispatch,
        "알림",
        `세션이 만료되었거나 지점이 변경되었습니다.\n 다시 로그인 해주세요`,
        true,
        () => {
          sessionStorage.clear();
          setIsAuth(false);
        },
      );
      return;
    }

    const time = dateTimeToStr(new Date());

    simpleAlert(
      storesDispatch,
      "알림",
      `${selectedBranch} 지점에서 선택하신 ${totalQuantity}개 기자재
       견적서를 생성하시겠습니까?`,
      false,
      () => {},
      () => {
        exportCartToExcel(cartItems, selectedBranch, time);
        saveToHistory();
      },
    );
  };
  // 구매목록 저장하기
  const saveToHistory = async () => {
    const branch = sessionStorage.getItem("branch");
    const historyRef = collection(db, "deploy", "estimate", "history");

    await addDoc(historyRef, {
      branch_name: branch,
      items: cartItems.map((item) => ({
        id: item.id,
        name: item.name,
        model: item.model,
        series: item.series,
        format: item.format,
        quantity: item.quantity,
        price: item.price,
        image: item.image,
      })),
      total_amount: cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0),
      created_at: dateTimeToStr(new Date()),
    });
  };

  // 최종 견적서 송부
  // const sendEmail = (e) => {
  //   e.preventDefault();
  //   setIsLoading(true);
  //   emailjs
  //     .sendForm("service_9j0z7sa", "template_0oqbqyd", emailForm.current, {
  //       publicKey: "77OLWmaha3o2PsEFH",
  //     })
  //     .then(
  //       () => {
  //         alert("구매 요청이 완료되었습니다.");
  //       },
  //       (error) => {
  //         console.log("FAILED...", error.text);
  //         alert("구매 요청에 실패했습니다.");
  //       },
  //     )
  //     .finally(() => {
  //       setIsLoading(false);
  //     });
  // };
  return (
    <>
      {isLoading && <Loading />}
      {/* <form ref={emailForm} style={{ display: "none" }} onSubmit={sendEmail}>
        <input type="text" name="title" />
        <input type="text" name="branch" />
        <input type="text" name="time" />
        <textarea name="message" />
      </form> */}

      {/* 사이드바 */}
      <div
        style={{
          width: "24rem",
          height: "36rem",

          padding: "0 10px",
          backgroundColor: "white",
          borderRadius: "8px",
          border: "1px solid #e0e0e0",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* 헤더 */}
        <div
          style={{
            padding: "10px",
            borderBottom: "1px solid #e0e0e0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2 style={{ margin: 0, fontSize: "20px" }}>견적서 ({totalQuantity})</h2>

          <button
            onClick={onClear}
            style={{
              background: "none",
              border: "none",
              fontSize: "24px",
              cursor: "pointer",
              color: "#666",
            }}
          >
            ✕
          </button>
        </div>

        {/* 견적서 아이템 리스트 */}
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "10px",
          }}
        >
          {cartItems.length === 0 ? (
            <div
              style={{
                textAlign: "center",
                color: "#999",
                marginTop: "40px",
              }}
            >
              견적서가 비어있습니다
            </div>
          ) : (
            cartItems.map((item) => (
              <div
                key={item.id}
                style={{
                  backgroundColor: "#f9f9f9",
                  padding: "16px",
                  borderRadius: "8px",
                  marginBottom: "12px",
                  display: "flex",
                  gap: "12px",
                }}
              >
                {/* 썸네일 */}
                <img
                  src={item.image}
                  alt={item.name}
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "6px",
                    objectFit: "cover",
                  }}
                />

                {/* 정보 */}
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: "600", marginBottom: "4px" }}>{item.name}</div>
                  <div style={{ fontSize: "12px", color: "#666" }}>
                    {item.series} • {item.model}
                  </div>
                  <div style={{ fontSize: "12px", color: "#999" }}>{item.format}</div>
                  {/* 단가 */}
                  {item.price !== null && (
                    <div style={{ fontSize: "12px", color: "#1976d2", marginTop: "2px" }}>
                      {item.price.toLocaleString()}원
                    </div>
                  )}

                  {/* 수량 컨트롤 */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "1rem",
                      marginTop: "6px",
                    }}
                  >
                    <button
                      onClick={() => onRemoveItem(item.id)}
                      style={{
                        width: "22px",
                        height: "22px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        cursor: "pointer",
                        background: "white",
                      }}
                    >
                      −
                    </button>
                    <span style={{ fontSize: "14px", fontWeight: "600" }}>{item.quantity}</span>
                    <button
                      onClick={() => onAddItem(item)} // 수량 증가
                      style={{
                        width: "22px",
                        height: "22px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        cursor: "pointer",
                        background: "white",
                      }}
                    >
                      +
                    </button>
                  </div>
                </div>

                {/* 삭제 버튼 */}
                <IconButton
                  type="delete"
                  onClick={() => onRemoveItem(item.id)}
                  svgWidth="20px"
                  svgHeight="20px"
                  color="#032063"
                />
              </div>
            ))
          )}
        </div>
        {/* 합계 */}
        {cartItems.some((i) => i.price) && (
          <div
            style={{
              padding: "8px 16px",
              borderTop: "1px solid #e0e0e0",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span style={{ fontSize: "13px", color: "#666" }}>합계</span>
            <span style={{ fontSize: "16px", fontWeight: "700", color: "#032063" }}>
              {cartItems.reduce((acc, i) => acc + (i.price || 0) * i.quantity, 0).toLocaleString()}
              원
            </span>
          </div>
        )}

        {/* 하단 버튼 영역 */}
        <div
          style={{
            display: "flex",
            gap: "10px",
            padding: "10px",
            borderTop: "1px solid #e0e0e0",
          }}
        >
          <button
            onClick={() => setIsHistoryModalOpen(true)}
            style={{
              flex: 1,
              padding: "10px",
              backgroundColor: "#fff",
              color: "#10134F",
              border: "1px solid #10134F",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            구매 이력 보기
          </button>
          <button
            onClick={onClickEstimate}
            disabled={cartItems.length === 0}
            style={{
              flex: 1,
              padding: "10px",
              backgroundColor: cartItems.length > 0 ? "#10134F" : "#ccc",
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: "600",
              cursor: cartItems.length > 0 ? "pointer" : "not-allowed",
            }}
          >
            구매 요청 ({totalQuantity}개)
          </button>
        </div>
      </div>
    </>
  );
};

export default CartSidebar;
